import React from 'react';
import { Spin, Icon } from 'antd';
import { colors } from 'components/theme/pure_ott_theme/colors';

const SimpleLoader = ({ size }) => {
	const antIcon = (
		<Icon
			type="loading-3-quarters"
			style={{ fontSize: size, color: colors.primary }}
			spin
		/>
	);
	return <Spin indicator={antIcon} />;
};

export default SimpleLoader;
